import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { getCheggTldFrom, getLangPreferenceCookie, CheggTlds } from '@chegg/utils';
var esLocales = ['es-MX', 'es-419', 'es'];
var DEFAULT_LANGUAGE_LOCALE = _defineProperty(_defineProperty({}, CheggTlds.MX, 'es-419'), CheggTlds["default"], 'en-US');
var enTexts = {
  mfaDialog: {
    backButtonLabel: 'Go Back'
  },
  factorSelector: {
    title: "Before signing in, let's make sure it's you",
    subTitle: 'Verifying with the app is easiest! We’ll guide you through a quick set-up, then it’s just one step to verify from here on out.',
    byAppLabel: 'Verify with app',
    byEmailLabel: 'Email code'
  },
  errorMessages: {
    generalError: {
      title: 'Sorry, let’s try that again',
      footer: 'We’re having some technical trouble on our end.<br>',
      footerLink: 'Try verifying again'
    },
    osPushDeclined: {
      title: 'Let’s get you verified a different way',
      body: 'If you want to switch to easy, 1-step verification with the app, head to your phone settings then <b>Chegg app</b>, then <b>notifications</b>, and tap ‘<b>allow</b>’.',
      footerLinkNavigation: 'Verify a different way'
    },
    appPushDeclined: {
      title: 'Sorry, we couldn’t verify your info',
      footerTextPart_1: 'No worries! Just sign in again and we’ll help you get<br> verified a different way.'
    },
    sessionBlocked: {
      bannerTitle: 'You have reached your re-send limit',
      bannerMessage: 'Please try again in 5 minutes.'
    },
    qrSessionExpired: {
      qrSessionExpiredTitle: 'This QR code expired',
      qrSessionExpiredMessage: 'Get a new code',
      qrSessionExpiredLink: 'here'
    },
    sentSessionExpired: {
      sessionExpiredTitle: 'Your session has expired',
      sessionExpiredMessage: 'Start a new session by clicking',
      sessionExpiredLink: 'here.'
    }
  },
  informationMessages: {
    notificationSent: {
      title: 'Ok, we sent a notification to your phone',
      footerTextPart_1: 'Give it a tap or open the app to continue.<br> No notification? ',
      footerResendLink: 'Resend',
      footerTextPart_2: ' or ',
      footerLinkNavigation: 'verify a different way.',
      bannerMessageOnRetry: 'Notification sent.'
    }
  },
  qr: {
    header: 'First, let’s get you set up in the app',
    bodyMessage: 'You’ll need to sign in and turn on notifications.<br>Scan the QR code to continue.'
  },
  timeout: {
    header: 'Let’s try that again',
    bodyMessage: 'Seems like setup took a little longer than expected. That’s ok!<br>Just sign in again to continue.'
  }
};
var esTexts = {
  mfaDialog: {
    backButtonLabel: 'Regresar'
  },
  factorSelector: {
    title: "Antes de iniciar sesi\xF3n, aseguremonos de que eres t\xFA",
    subTitle: 'Verificar con la app es lo más fácil. Te guiaremos a través de una configuración rápida, luego solo será un paso para verificar a partir de aquí.',
    byAppLabel: 'Verificar con la app',
    byEmailLabel: 'Código por correo'
  },
  errorMessages: {
    generalError: {
      title: 'Lo siento, intentemos de nuevo',
      footer: 'Estamos teniendo algunos problemas técnicos de nuestro lado.<br>',
      footerLink: 'Intenta verificar de nuevo'
    },
    osPushDeclined: {
      title: 'Vamos a verificarte de otra manera',
      body: 'Si quieres cambiar a una verificación fácil en un solo paso con la app, ve a la configuración de tu teléfono, luego a <b>app de Chegg</b>, después a <b>notificaciones</b>, y toca ‘<b>permitir</b>‘.',
      footerLinkNavigation: 'Verificar de otra manera'
    },
    appPushDeclined: {
      title: 'Lo siento, no pudimos verificar tu información',
      footerTextPart_1: '¡No te preocupes! Solo vuelve a iniciar sesión y te ayudaremos a verificarte de otra manera.'
    },
    sessionBlocked: {
      bannerTitle: 'Has alcanzado el límite de reenvíos',
      bannerMessage: 'Por favor, intenta de nuevo en 5 minutos.'
    },
    qrSessionExpired: {
      qrSessionExpiredTitle: 'Este código QR ha expirado',
      qrSessionExpiredMessage: 'Obtén un nuevo código',
      qrSessionExpiredLink: 'aquí'
    },
    sentSessionExpired: {
      sessionExpiredTitle: 'Tu sesión ha expirado',
      sessionExpiredMessage: 'Inicia una nueva sesión haciendo clic',
      sessionExpiredLink: 'aquí.'
    }
  },
  informationMessages: {
    notificationSent: {
      title: 'Ok, enviamos una notificación a tu teléfono',
      footerTextPart_1: 'Tócalo o abre la app para continuar.<br> ¿No recibiste la notificación? ',
      footerResendLink: 'Reenviar',
      footerTextPart_2: 'o',
      footerLinkNavigation: 'verifica de otra manera.',
      bannerMessageOnRetry: 'Notificación enviada.'
    }
  },
  qr: {
    header: 'Primero, vamos a configurar la app',
    bodyMessage: 'Necesitarás iniciar sesión y activar las notificaciones.'
  },
  timeout: {
    header: 'Intentémoslo de nuevo',
    bodyMessage: 'Parece que la configuración tomó un poco más de tiempo del esperado. ¡Está bien! Solo inicia sesión de nuevo para continuar.'
  }
};
export function getTexts() {
  var _getLangPreferenceCoo;
  var tld = typeof window !== 'undefined' ? getCheggTldFrom(window.location.origin) : '.com';
  var locale = (_getLangPreferenceCoo = getLangPreferenceCookie()) !== null && _getLangPreferenceCoo !== void 0 ? _getLangPreferenceCoo : tld ? DEFAULT_LANGUAGE_LOCALE[tld] : 'en-US';
  return esLocales.includes(locale) ? esTexts : enTexts;
}